// extracted by mini-css-extract-plugin
module.exports = {"container":"History_container__1lehp","history_container":"History_history_container__3cqaN","box":"History_box__3alpa"};